module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aback1-93725907bd1eddc881d5076323a7e491.jpg";